import TEXT from './generated/TEXT/consts';

TEXT.DEFINE({
  afrikaans: 'Afrikaans',
  azerbaijani: 'Azerbaijani',
  bashkir: 'Bashkir',
  belarusian: 'Belarusian',
  bulgarian: 'Bulgarian',
  bengali: 'Bengali',
  catalan: 'Catalan',
  mandarinSimplified: 'Mandarin (Simplified)',
  mandarinTraditional: 'Mandarin (Traditional)',
  welsh: 'Welsh',
  danish: 'Danish',
  german: 'German',
  englishAustralia: 'English (AU)',
  englishCanada: 'English (CA)',
  englishUnitedKingdom: 'English (UK)',
  englishIndia: 'English (I)',
  englishNewZealand: 'English (NZ)',
  englishUnitedStates: 'English (US)',
  esperanto: 'Esperanto',
  spanish: 'Spanish',
  estonian: 'Estonian',
  basque: 'Basque',
  persian: 'Persian',
  finnish: 'Finnish',
  french: 'French',
  irish: 'Irish',
  galician: 'Galician',
  hindi: 'Hindi',
  croatian: 'Croatian',
  hungarian: 'Hungarian',
  interlingua: 'Interlingua',
  italian: 'Italian',
  japanese: 'Japanese',
  korean: 'Korean',
  lithuanian: 'Lithuanian',
  latvian: 'Latvian',
  macedonian: 'Macedonian',
  mongolian: 'Mongolian',
  malay: 'Malay',
  maltese: 'Maltese',
  marathi: 'Marathi',
  norwegian: 'Norwegian',
  dutch: 'Dutch',
  polish: 'Polish',
  portuguese: 'Portuguese',
  romanian: 'Romanian',
  russian: 'Russian',
  slovak: 'Slovak',
  slovenian: 'Slovenian',
  serbian: 'Serbian',
  swedish: 'Swedish',
  swahili: 'Swahili',
  tamil: 'Tamil',
  thai: 'Thai',
  uyghur: 'Uyghur',
  urdu: 'Urdu',
  cantonese: 'Cantonese',
  arabic: 'Arabic',
  auto: 'Auto',
  czech: 'Czech',
  greek: 'Greek',
  hebrew: 'Hebrew',
  indonesian: 'Indonesian',
  turkish: 'Turkish',
  ukrainian: 'Ukrainian',
  vietnamese: 'Vietnamese',
});

export const localeMap = {
  'af-ZA': {
    get language() {
      return TEXT.afrikaans;
    },
    country: 'South Africa',
  },
  'az-AZ': {
    get language() {
      return TEXT.azerbaijani;
    },
    country: 'Azerbaijan',
  },
  'ba-RU': {
    get language() {
      return TEXT.bashkir;
    },
    country: 'Russia',
  },
  'be-BY': {
    get language() {
      return TEXT.belarusian;
    },
    country: 'Belarus',
  },
  'bg-BG': {
    get language() {
      return TEXT.bulgarian;
    },
    country: 'Bulgaria',
  },
  'bn-BD': {
    get language() {
      return TEXT.bengali;
    },
    country: 'Bangladesh',
  },
  'ca-ES': {
    get language() {
      return TEXT.catalan;
    },
    country: 'Spain',
  },
  'cmn-Hans': {
    get language() {
      return TEXT.mandarinSimplified;
    },
  },
  'cmn-Hant': {
    get language() {
      return TEXT.mandarinTraditional;
    },
  },
  'cy-GB': {
    get language() {
      return TEXT.welsh;
    },
    country: 'United Kingdom',
  },
  'da-DK': {
    get language() {
      return TEXT.danish;
    },
    country: 'Denmark',
  },
  'de-DE': {
    get language() {
      return TEXT.german;
    },
    country: 'Germany',
  },
  'en-AU': {
    get language() {
      return TEXT.englishAustralia;
    },
    country: 'Australia',
  },
  'en-CA': {
    get language() {
      return TEXT.englishCanada;
    },
    country: 'Canada',
  },
  'en-GB': {
    get language() {
      return TEXT.englishUnitedKingdom;
    },
    country: 'United Kingdom',
  },
  'en-IN': {
    get language() {
      return TEXT.englishIndia;
    },
    country: 'India',
  },
  'en-NZ': {
    get language() {
      return TEXT.englishNewZealand;
    },
    country: 'New Zealand',
  },
  'en-US': {
    get language() {
      return TEXT.englishUnitedStates;
    },
    country: 'United States',
  },
  'eo-EO': {
    get language() {
      return TEXT.esperanto;
    },
    country: 'International',
  },
  'es-AR': {
    get language() {
      return TEXT.spanish;
    },
    country: 'Argentina',
  },
  'es-ES': {
    get language() {
      return TEXT.spanish;
    },
    country: 'Spain',
  },
  'es-MX': {
    get language() {
      return TEXT.spanish;
    },
    country: 'Mexico',
  },
  'et-EE': {
    get language() {
      return TEXT.estonian;
    },
    country: 'Estonia',
  },
  'eu-ES': {
    get language() {
      return TEXT.basque;
    },
    country: 'Spain',
  },
  'fa-IR': {
    get language() {
      return TEXT.persian;
    },
    country: 'Iran',
  },
  'fi-FI': {
    get language() {
      return TEXT.finnish;
    },
    country: 'Finland',
  },
  'fr-BE': {
    get language() {
      return TEXT.french;
    },
    country: 'Belgium',
  },
  'fr-CA': {
    get language() {
      return TEXT.french;
    },
    country: 'Canada',
  },
  'fr-FR': {
    get language() {
      return TEXT.french;
    },
    country: 'France',
  },
  'ga-IE': {
    get language() {
      return TEXT.irish;
    },
    country: 'Ireland',
  },
  'gl-ES': {
    get language() {
      return TEXT.galician;
    },
    country: 'Spain',
  },
  'hi-IN': {
    get language() {
      return TEXT.hindi;
    },
    country: 'India',
  },
  'hr-HR': {
    get language() {
      return TEXT.croatian;
    },
    country: 'Croatia',
  },
  'hu-HU': {
    get language() {
      return TEXT.hungarian;
    },
    country: 'Hungary',
  },
  'ia-IA': {
    get language() {
      return TEXT.interlingua;
    },
    country: 'International',
  },
  'it-IT': {
    get language() {
      return TEXT.italian;
    },
    country: 'Italy',
  },
  'ja-JP': {
    get language() {
      return TEXT.japanese;
    },
    country: 'Japan',
  },
  'ko-KR': {
    get language() {
      return TEXT.korean;
    },
    country: 'South Korea',
  },
  'lt-LT': {
    get language() {
      return TEXT.lithuanian;
    },
    country: 'Lithuania',
  },
  'lv-LV': {
    get language() {
      return TEXT.latvian;
    },
    country: 'Latvia',
  },
  'mk-MK': {
    get language() {
      return TEXT.macedonian;
    },
    country: 'North Macedonia',
  },
  'mn-MN': {
    get language() {
      return TEXT.mongolian;
    },
    country: 'Mongolia',
  },
  'ms-MY': {
    get language() {
      return TEXT.malay;
    },
    country: 'Malaysia',
  },
  'mt-MT': {
    get language() {
      return TEXT.maltese;
    },
    country: 'Malta',
  },
  'mr-IN': {
    get language() {
      return TEXT.marathi;
    },
    country: 'India',
  },
  'nb-NO': {
    get language() {
      return TEXT.norwegian;
    },
    country: 'Norway',
  },
  'nl-BE': {
    get language() {
      return TEXT.dutch;
    },
    country: 'Belgium',
  },
  'nl-NL': {
    get language() {
      return TEXT.dutch;
    },
    country: 'Netherlands',
  },
  'pl-PL': {
    get language() {
      return TEXT.polish;
    },
    country: 'Poland',
  },
  'pt-BR': {
    get language() {
      return TEXT.portuguese;
    },
    country: 'Brazil',
  },
  'pt-PT': {
    get language() {
      return TEXT.portuguese;
    },
    country: 'Portugal',
  },
  'ro-RO': {
    get language() {
      return TEXT.romanian;
    },
    country: 'Romania',
  },
  'ru-RU': {
    get language() {
      return TEXT.russian;
    },
    country: 'Russia',
  },
  'sk-SK': {
    get language() {
      return TEXT.slovak;
    },
    country: 'Slovakia',
  },
  'sl-SI': {
    get language() {
      return TEXT.slovenian;
    },
    country: 'Slovenia',
  },
  'sr-RS': {
    get language() {
      return TEXT.serbian;
    },
    country: 'Serbia',
  },
  'sv-SE': {
    get language() {
      return TEXT.swedish;
    },
    country: 'Sweden',
  },
  'sw-KE': {
    get language() {
      return TEXT.swahili;
    },
    country: 'Kenya',
  },
  'ta-IN': {
    get language() {
      return TEXT.tamil;
    },
    country: 'India',
  },
  'th-TH': {
    get language() {
      return TEXT.thai;
    },
    country: 'Thailand',
  },
  'ug-CN': {
    get language() {
      return TEXT.uyghur;
    },
    country: 'China',
  },
  'ur-PK': {
    get language() {
      return TEXT.urdu;
    },
    country: 'Pakistan',
  },
  'zh-CN': {
    get language() {
      return TEXT.mandarinSimplified;
    },
    country: 'China',
  },
  'zh-HK': {
    get language() {
      return TEXT.cantonese;
    },
    country: 'Hong Kong',
  },
  'zh-TW': {
    get language() {
      return TEXT.mandarinTraditional;
    },
    country: 'Taiwan',
  },

  // Single language locale codes specific to DVA API
  ar: {
    get language() {
      return TEXT.arabic;
    },
    country: 'Saudi Arabia',
  },
  auto: {
    get language() {
      return TEXT.auto;
    },
  },
  cs: {
    get language() {
      return TEXT.czech;
    },
    country: 'Czech Republic',
  },
  el: {
    get language() {
      return TEXT.greek;
    },
    country: 'Greece',
  },
  he: {
    get language() {
      return TEXT.hebrew;
    },
    country: 'Israel',
  },
  id: {
    get language() {
      return TEXT.indonesian;
    },
    country: 'Indonesia',
  },
  tr: {
    get language() {
      return TEXT.turkish;
    },
    country: 'Turkey',
  },
  uk: {
    get language() {
      return TEXT.ukrainian;
    },
    country: 'Ukraine',
  },
  vi: {
    get language() {
      return TEXT.vietnamese;
    },
    country: 'Vietnam',
  },
} as const;

export const inputLocaleMap: Partial<{
  [K in keyof LocaleMap]: Pick<LocaleMap[K], 'language'>;
}> = {
  ar: {
    get language() {
      return TEXT.arabic;
    },
  },
  auto: {
    get language() {
      return TEXT.auto;
    },
  },
  'da-DK': {
    get language() {
      return TEXT.danish;
    },
  },
  'de-DE': {
    get language() {
      return TEXT.german;
    },
  },
  cs: {
    get language() {
      return TEXT.czech;
    },
  },
  el: {
    get language() {
      return TEXT.greek;
    },
  },
  'en-GB': {
    get language() {
      return TEXT.englishUnitedKingdom;
    },
  },
  'en-US': {
    get language() {
      return TEXT.englishUnitedStates;
    },
  },
  'es-ES': {
    get language() {
      return TEXT.spanish;
    },
  },
  'fr-FR': {
    get language() {
      return TEXT.french;
    },
  },
  he: {
    get language() {
      return TEXT.hebrew;
    },
  },
  'hi-IN': {
    get language() {
      return TEXT.hindi;
    },
  },
  id: {
    get language() {
      return TEXT.indonesian;
    },
  },
  'it-IT': {
    get language() {
      return TEXT.italian;
    },
  },
  'ja-JP': {
    get language() {
      return TEXT.japanese;
    },
  },
  'ko-KR': {
    get language() {
      return TEXT.korean;
    },
  },
  'nb-NO': {
    get language() {
      return TEXT.norwegian;
    },
  },
  'nl-NL': {
    get language() {
      return TEXT.dutch;
    },
  },
  'pl-PL': {
    get language() {
      return TEXT.polish;
    },
  },
  'pt-PT': {
    get language() {
      return TEXT.portuguese;
    },
  },
  'ru-RU': {
    get language() {
      return TEXT.russian;
    },
  },
  'sv-SE': {
    get language() {
      return TEXT.swedish;
    },
  },
  tr: {
    get language() {
      return TEXT.turkish;
    },
  },
  uk: {
    get language() {
      return TEXT.ukrainian;
    },
  },
  vi: {
    get language() {
      return TEXT.vietnamese;
    },
  },
  'zh-CN': {
    get language() {
      return TEXT.mandarinSimplified;
    },
  },
  'zh-HK': {
    get language() {
      return TEXT.cantonese;
    },
  },
  'zh-TW': {
    get language() {
      return TEXT.mandarinTraditional;
    },
  },
} as const;

export type Language = (typeof localeMap)[keyof typeof localeMap]['language'];
export type LocaleMap = typeof localeMap;
export type InputLocaleKey = keyof typeof inputLocaleMap;
export type LocaleKey = keyof typeof localeMap;
